import { Text } from '@components/text'
import { PolicyCategory } from '@contentful-components/policy-category'
import type { PolicyCategoryFragment } from '@graphql/fragments/PolicyCategoryFragment.graphql'
import { categoryHasPolicies } from '@lib/utils/policy'
import { TEXT } from '@lib/utils/text'
import type { FunctionComponent } from 'react'

import styles from './policy-sidebar.module.scss'

export const PolicySidebar: FunctionComponent<Props> = ({ categories }) => {
    // only display category if it has policies
    const filteredCategories = categories
        ?.filter(categoryHasPolicies)
        .map((category) => (
            <PolicyCategory
                key={category.slug}
                {...category}
                variant='sidebar'
            />
        ))

    return (
        <div className={styles['policy-sidebar']}>
            <Text
                typeStyle={{
                    _: 'heading-xs',
                    lg: 'heading-md',
                }}
                className={styles['policy-sidebar--title']}
            >
                {TEXT.policies.sidebarTitle}
            </Text>

            {filteredCategories}
        </div>
    )
}

export default PolicySidebar

interface Props {
    categories?: PolicyCategoryFragment[]
}
